import { Location } from "history";
import { createSearchParams } from "react-router-dom-v5-compat";

import { SpeedyMarkingMode } from "features/teachers/pages/assignment/components/SpeedyMarking/SpeedyMarkingSession";
import { ROUTES } from "routing/routes";

export function linkToAssignmentSpeedyMarking(
  classId?: string,
  assignmentId?: string,
  search?: {
    mode: SpeedyMarkingMode;
  },
  state?: {
    selectedQuestionIds: string[];
  }
) {
  const link: Partial<Location> = {
    search: `?${createSearchParams({ mode: search?.mode ?? "" })}`,
    state
  };

  if (classId && assignmentId) {
    link.pathname = `${ROUTES.TEACHER.CLASS.ASSIGNMENTS.ASSIGNMENT.buildPath({
      classId,
      assignmentId
    })}/speedy-marking`;
  } else {
    link.pathname = `${ROUTES.TEACHER.CLASS.ASSIGNMENTS.ASSIGNMENT.path}/speedy-marking`;
  }

  return link as Location;
}
